export default "__VITE_ASSET__BxTtGda9__"